import {FrontEndTextDto} from "../../../core/interfaces/core.types";

export interface UserPhotoDto {

  dataBase64: string;
  mimeType: string;

}

export interface ProfileDto {

  firstName: string;
  lastName: string;

  email: string;
  emailConfirmed: boolean;
  phoneNumber: string;

  exUserPhotoDto: UserPhotoDto;

  address: string,
  birthDate: string | undefined;
  uiBirthDate: string | undefined;

}

export interface UserDocumentDto {

  id: number;
  name: string;
  mimeType: string;
  additionalInformation: string;
  uploadedOn: string;

}


export enum CustomerOnboardingInternalStatus {
  missing,
  pending,
  appointment_missing,
  schedule_pending,
  scheduled,
  completed,
  not_available

}


export interface BasicDataResponseDto {

  userImageBase64: string;
  emailActivated: boolean;
  frontEndTexts: FrontEndTextDto[];
  onboardingOnRegistrationStatus: CustomerOnboardingInternalStatus;
  onboardingOnRegistrationTypeId: number;
}

export interface DtoReferFriend {
  text: string;
}
